import styled from 'styled-components';

export const ClonarProdutoContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;

  input {
    width: 34.375rem;
  }

  @media only screen and (max-width: 991px) {
    flex-direction: column;

    input {
      width: 29.0625rem;
    }
  }

  .button-content {
    display: flex;
    gap: 0.3125rem;

    button {
      margin-top: 1.875rem;
      padding: 0.4375rem;
      border: none;
      width: 6.25rem;
      text-transform: uppercase;
      border-radius: 0.1875rem;
      color: white;

      &:hover {
        opacity: 85%;
      }

      &:disabled {
        cursor: not-allowed;
        opacity: 70%;
      }
    }
  }
`;
